<script setup>
import { Button } from '@aryeo/runway'
import { router } from '@inertiajs/vue3'
import { computed, ref } from 'vue'

import { useFeatureFlags } from '@/Hooks/Company/useFeatureFlags.js'
import { usePermissions } from '@/Hooks/Company/usePermissions.js'

const props = defineProps({
  customerTeamId: String,
  iconName: {
    type: String,
    default: 'plus',
  },
  text: {
    type: String,
    default: 'Create Listing',
  },
})

const { hasFeatureFlag } = useFeatureFlags()
const { hasPermission } = usePermissions()

const isDisabled = ref(false)

const buttonText = computed(() =>
  hasFeatureFlag('listings_new_creation_flow') ? props.text : 'Create Listing'
)

const createListing = (event) => {
  isDisabled.value = true

  const createListingRoute = hasFeatureFlag('listings_new_creation_flow')
    ? 'web.company.listings.create-new'
    : 'web.company.listings.create'

  router.visit(route(createListingRoute, { customer_team_id: props.customerTeamId }), {
    onSuccess: () => (isDisabled.value = false),
  })
}
</script>

<template>
  <Button
    v-if="hasPermission('listing_create')"
    type="button"
    :disabled="isDisabled"
    :text="buttonText"
    :iconName
    @click="createListing"
  />
</template>
